import { ReactNode, useId } from 'react';
import { Flex } from 'antd';
import { Text } from '../Ant';

interface ILabelledRadioGroupProps {
  title: string;
  testId: string;
  children: ReactNode;
}

// antd's Radio.Group renders no radiogroup role, so the wrapper names the group after its title.
const LabelledRadioGroup = ({ title, testId, children }: ILabelledRadioGroupProps) => {
  const titleId = useId();

  return (
    <Flex vertical gap={10}>
      <Text id={titleId} $fontsize="12px" $weight={500} $lineheight="16px" $color="subtitle">
        {title}
      </Text>
      <div role="radiogroup" aria-labelledby={titleId} data-testid={testId}>
        {children}
      </div>
    </Flex>
  );
};

export default LabelledRadioGroup;
